export class DwnConstant {
  /**
   * The maximum size in bytes of raw data that will be returned as `encodedData`.
   */
  public static readonly maxDataSizeAllowedToBeEncoded = 10_000;
}